import _getIterator from 'babel-runtime/core-js/get-iterator';
import _Set from 'babel-runtime/core-js/set';
export var reorderTaskType = 'reorderTask';
export var newTaskAssignedType = 'newTaskAssigned';

export var getNotificationsByTaskId = function getNotificationsByTaskId(notifications, taskId) {
  if (!taskId) {
    return [];
  }
  return notifications && notifications.filter(function (n) {
    return n.taskId === taskId;
  });
};

export var getNotificationsTypeSet = function getNotificationsTypeSet(notifications) {
  var set = new _Set();
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _getIterator(notifications), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var notification = _step.value;

      set.add(notification.type);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return set;
};

export var getUnreadNotificationsByTaskId = function getUnreadNotificationsByTaskId(notifications, taskId) {
  if (!taskId) {
    return [];
  }
  return notifications && notifications.filter(function (n) {
    return n.taskId === taskId && !n.read;
  });
};
//# sourceMappingURL=notifications.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-misc/lib/utils/notifications.js
// module id = 757
// module chunks = 0